import { Button, ButtonProps, Heading, Stack, Text, VStack } from '@chakra-ui/react'

import { CheckmarkIcon, ExclamationIcon, IconPropsType } from 'components/SVGS'

interface CardCustomResultProps extends IconPropsType {
  onSubmit: () => void
  headerTitle?: string
  text?: string
  type?: 'success' | 'error' | 'custom'
  icon?: React.FC<IconPropsType>
  primaryButtonText?: string
  primaryButtonProps?: ButtonProps
}

export const CardCustomResult: React.FC<CardCustomResultProps> = ({
  onSubmit,
  text,
  headerTitle,
  type = 'success',
  icon: IconCustom,
  primaryButtonText = 'Entendido',
  primaryButtonProps,
  ...props
}) => {
  return (
    <VStack w={'full'} p={{ base: 0, md: 8 }} spacing={4} alignItems={'center'} justifyContent={'center'}>
      {type === 'custom' && IconCustom
        ? <IconCustom {...props} />
        : type === 'success'
          ? <CheckmarkIcon size={'70px'} />
          : <ExclamationIcon size={'70px'} />
      }
      {headerTitle && <Heading textAlign={'center'} variant={'MD'}>{headerTitle}</Heading>}
      {text && <Text variant={{ base: 'SM', md: 'MD' }} textAlign={{ base: 'left', md: 'center' }}>{text}</Text>}
      <Stack w={'full'}>
        <Button {...primaryButtonProps} minW={'50%'} onClick={onSubmit}>{primaryButtonText}</Button>
      </Stack>
    </VStack>
  )
}
